import { mediaMinWidth } from '@lux/core';
import styled from 'styled-components';

export const NotificationWrapper = styled.div`
    position: fixed;
    z-index: 2000;
    top: 60px;
    height: 40px;
    width: 100%;

    ${mediaMinWidth.sm} {
        top: 75px;
    }
`;
